<div class="login-container">
	<!-- Neural Background -->
	<canvas #neuralCanvas class="neural-canvas"></canvas>

	<!-- Header -->
	<div class="header">
		<div class="header-content">
			<img [src]="loginLogoLeftUrl" alt="P.A.N.D.A Logo" class="logo" />
			<img [src]="loginLogoRightUrl" alt="Partner Logo" class="partner-logo" />
		</div>
	</div>

	<!-- Main Content -->
	<div class="main-content">
		<div class="login-card">
			<!-- Left Side - Form -->
			<div class="form-section">
				<div class="logo-section">
					<img [src]="loginImageLeftUrl" alt="NFMW Logo" class="main-logo" />
				</div>

				<!-- Dynamic Content -->
				<div [ngSwitch]="mode" class="form-container">
					<app-login-form *ngSwitchCase="'Login'" [agent]="agent!" (doUpdateState)="doUpdateState($event)"></app-login-form>
					<app-forgot-password-form *ngSwitchCase="'ForgotPassword'" [agent]="agent!" (doUpdateState)="doUpdateState($event)"></app-forgot-password-form>
					<app-blocked *ngSwitchCase="'Blocked'" [agent]="agent!" (doUpdateState)="doUpdateState($event)"></app-blocked>
					<app-suspended *ngSwitchCase="'Suspended'" [agent]="agent!" (doUpdateState)="doUpdateState($event)"></app-suspended>
					<app-two-factor-auth *ngSwitchCase="'TwoFactorAuth'" [agent]="agent!" [credentials]="credentials!" (doUpdateState)="doUpdateState($event)"></app-two-factor-auth>
				</div>

				<p class="copyright">
					© 2025 P.A.N.D.A — All Rights Reserved {{getCounter()}}
				</p>
			</div>

			<!-- Right Side - Image -->
			<div class="image-section">
				<img [src]="loginImageRightUrl" alt="Login Illustration" class="side-image" />
			</div>
		</div>
	</div>
</div>
